import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';
import { analytics } from '../utils/analytics';

/**
 * Hook to track page views when route changes
 */
export const usePageTracking = () => {
  const location = useLocation();

  useEffect(() => {
    // Only track in production if analytics is enabled
    if (import.meta.env.PROD && import.meta.env.VITE_ENABLE_ANALYTICS === 'true') {
      const pageTitle = document.title || 'Personal Training Platform';
      
      analytics.pageView({
        page_path: location.pathname + location.search,
        page_title: pageTitle,
      });
    }
  }, [location]);
};
